import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Environment} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {ShowcaseContextService} from './showcase-context.service';

const SHOWCASE_BYPASS_PREFIXES = [
  '/showcase/',
  '/refresh',
  '/auth-anonymous',
  '/init',
  '/menu',
];

@Injectable()
export class ShowcaseHashInterceptor implements HttpInterceptor {
  private readonly ctx = inject(ShowcaseContextService);
  private readonly environment = inject(Environment);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const hash = this.ctx.hash;
    if (!hash) {
      return next.handle(req);
    }

    const apiBase = this.environment.serverApi;
    if (!req.url.startsWith(apiBase)) {
      return next.handle(req);
    }

    const path = req.url.slice(apiBase.length);
    if (this.shouldBypass(path)) {
      return next.handle(req);
    }

    const rewritten = `${apiBase}/showcase/${hash}${path}`;
    return next.handle(req.clone({url: rewritten}));
  }

  private shouldBypass(path: string): boolean {
    return SHOWCASE_BYPASS_PREFIXES.some(prefix => {
      if (!path.startsWith(prefix)) {
        return false;
      }
      // Для `/showcase/...` bypass-им любые продолжения (URL уже содержит hash явно);
      // для остальных — только точный конец/separator, чтобы не зацепить `/initial` под `/init`.
      if (prefix === '/showcase/') {
        return true;
      }
      const next = path.charAt(prefix.length);
      return next === '' || next === '/' || next === '?';
    });
  }
}
